var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgSpiralBlackHt = function SvgSpiralBlackHt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 7,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.338 5.444h-.065c-4.168-.34-4.47-2.213-7.078-2.213-3.044 0-5.148 3.059-8.669 3.059-3.93 0-5.386-3.395-7.93-3.395C11.652 2.895 9.348 7 5.03 7 2.586 7 0 5.508 0 3.194 0 1.865 1.197 1.72 1.428 1.72c1.618 0 1.284 2.396 3.445 2.396C8.304 4.116 10.423 0 15.658 0c3.874 0 5.303 3.412 7.84 3.412 2.04 0 5.378-3.133 8.728-3.133 3.116 0 5.122 2.44 7.79 2.44 2.303 0 2.085-2.515 3.56-2.515 1.03 0 1.424.97 1.424 1.414 0 .986-1.596 3.826-5.662 3.826z",
    fill: "#170426"
  })));
};
export default SvgSpiralBlackHt;